export default __webpack_public_path__ + "static/media/tax-outline-16px.69d18710.svg";